import { Tooltip as MuiTooltip } from '@mui/material';
import React from 'react';
import styled from 'styled-components';

export const Tooltip = styled(MuiTooltip)`
  font-size: 1rem;
`;
